import { CheckoutError } from "../../CheckoutError";
import type { PaywallCheckoutAttemptsMode } from "../types";
import { paywallCheckoutAttemptsModes } from "../types";

interface UseExpressModeParams {
  memberProcessorCustomerSessionClientSecret?: string;
  mode: PaywallCheckoutAttemptsMode;
}

/**
 * Handles express checkout mode validation and state.
 * Express mode uses saved payment methods for one-click purchases (e.g., upsells).
 *
 * In Express Mode, we don't render PaymentElement at all. The backend validates
 * that a valid payment method exists before showing the upsell page. We only need
 * the Stripe Elements instance (not the PaymentElement UI) to confirm payments.
 */
export const useExpressMode = ({
  memberProcessorCustomerSessionClientSecret,
  mode,
}: UseExpressModeParams) => {
  const isExpressMode = mode === paywallCheckoutAttemptsModes.express;

  // customerSessionClientSecret is required to access saved payment methods
  if (isExpressMode && !memberProcessorCustomerSessionClientSecret) {
    throw new CheckoutError(
      "useExpressMode.validation",
      "Express mode requires customerSessionClientSecret to access saved payment methods",
    );
  }

  return { isExpressMode };
};
